import "./stepper.css";
 
export const Stepper = ({ stepper, active, setActive }) => {
  const handleStepClick = (index) => {
    setActive(index);
  };
 
  const getStepClass = (index) => {
    if (index <= active) return "step active"; // current + previous
    return "step"; // future steps
  };
 
  return (
    <div className="parent">
      {stepper.map((item, ind) => (
        <div
          key={ind}
          className={`steper ${getStepClass(ind)}`}
          onClick={() => handleStepClick(ind)}
        >
          {item}
        </div>
      ))}
    </div>
  );
};